module.exports = __webpack_public_path__ + "img/newtaiyo6.c2fd1749.png";